export function setPropertyValue(props, key, value) {
  if (!props) return false;

  // Cesium PropertyBag
  if (typeof props.get === "function") {
    const property = props.get(key);
    if (property && typeof property.setValue === "function") {
      property.setValue(value);
      return true;
    }
    if (typeof props.addProperty === "function") {
      props.addProperty(key, value);
      return true;
    }
  }

  // Internal bag
  if (props._properties && typeof props._properties === "object") {
    const property = props._properties[key];
    if (property && typeof property.setValue === "function") {
      property.setValue(value);
      return true;
    }
    props._properties[key] = value;
    return true;
  }

  // Plain object
  props[key] = value;
  return true;
}
